module.exports = __webpack_public_path__ + "static/img/info-template4.51f27c9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/info-template4.png
// module id = F55w
// module chunks = 1